import React from 'react'

import clsx from 'clsx'

import { EventContext } from 'context/EventContext'
import { useListingDetailContext } from 'context/ListingDetailContext'

import PopularComparisonsContent from '../../../PopularComparisons'
import TextBase from '../TextBase'

/** @type {import("./types").default} */
const PopularComparisons = ({ className }) => {
  const { listing } = useListingDetailContext()

  return (
    <section className={clsx('PopularComparisons', className)}>
      <TextBase title={`Popular comparisons with ${listing.name}`} />
      <EventContext value={{ engagementComponent: 'product_comparisons' }}>
        <PopularComparisonsContent listing={listing} gridProps={{ xs: 12, sm: 6, md: 4 }} />
      </EventContext>
    </section>
  )
}

export default PopularComparisons
